import * as globalVars from 'settings/globalVars';
import axios from 'axios';

export function getInstance(){
    var instance = axios.create({
        baseURL: globalVars.getCalAmpBaseUri(),
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8',
            'calamp-services-app':globalVars.getCalAmpAppKey(),
            'Authorization': 'Bearer ' + globalVars.getJasperSessionId()
            },
        crossdomain: true,
        withCredentials: true,
        xhrFields: {
            'withCredentials': 'true'
        }
      });

      return instance;
}



// WEBPACK FOOTER //
// ./src/services/apis/jasper/httpHolder.js